var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenealogyFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 30,
    rx: 15,
    fill: "#6FCF97"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13377_3002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6697 18.7499H25.2717C25.0443 17.978 24.3492 17.4106 23.5197 17.4106C22.6903 17.4106 21.9957 17.978 21.7678 18.7499H15.1197C14.8299 18.7499 14.5947 18.9899 14.5947 19.2857C14.5947 19.5814 14.8299 19.8214 15.1197 19.8214H21.7678C21.9951 20.5933 22.6902 21.1606 23.5197 21.1606C24.3492 21.1606 25.0438 20.5933 25.2716 19.8214H26.6697C26.96 19.8214 27.1947 19.5814 27.1947 19.2857C27.1947 18.9899 26.96 18.7499 26.6697 18.7499ZM23.5197 20.0892C23.0856 20.0892 22.7322 19.7287 22.7322 19.2857C22.7322 18.8426 23.0856 18.4821 23.5197 18.4821C23.9539 18.4821 24.3072 18.8426 24.3072 19.2857C24.3072 19.7287 23.9539 20.0892 23.5197 20.0892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6697 10.1784H25.2717C25.0438 9.40643 24.3492 8.83911 23.5197 8.83911C22.6903 8.83911 21.9957 9.40643 21.7678 10.1784H15.1197C14.8299 10.1784 14.5947 10.4184 14.5947 10.7141C14.5947 11.0098 14.8299 11.2498 15.1197 11.2498H21.7678C21.9957 12.0218 22.6902 12.5891 23.5197 12.5891C24.3492 12.5891 25.0438 12.0218 25.2717 11.2498H26.6697C26.9601 11.2498 27.1947 11.0098 27.1947 10.7141C27.1947 10.4184 26.9601 10.1784 26.6697 10.1784ZM23.5197 11.5177C23.0856 11.5177 22.7322 11.1571 22.7322 10.7141C22.7322 10.2711 23.0856 9.91052 23.5197 9.91052C23.9539 9.91052 24.3072 10.2711 24.3072 10.7141C24.3072 11.1571 23.9539 11.5177 23.5197 11.5177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6697 14.464H20.0217C19.7938 13.6921 19.0992 13.1248 18.2697 13.1248C17.4403 13.1248 16.7457 13.6921 16.5178 14.464H15.1197C14.8299 14.464 14.5947 14.704 14.5947 14.9997C14.5947 15.2955 14.8299 15.5355 15.1197 15.5355H16.5178C16.7457 16.3074 17.4402 16.8747 18.2697 16.8747C19.0992 16.8747 19.7938 16.3074 20.0216 15.5355H26.6697C26.96 15.5355 27.1947 15.2955 27.1947 14.9997C27.1947 14.704 26.96 14.464 26.6697 14.464ZM18.2697 15.8033C17.8355 15.8033 17.4822 15.4428 17.4822 14.9997C17.4822 14.5567 17.8355 14.1962 18.2697 14.1962C18.7039 14.1962 19.0572 14.5567 19.0572 14.9997C19.0572 15.4428 18.7039 15.8033 18.2697 15.8033Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13377_3002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6,
    height: 12.8571,
    fill: "white",
    transform: "translate(14.5947 8.57129)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenealogyFilterIcon);
export default __webpack_public_path__ + "static/media/GenealogyFilterIcon.0dd1caf717f05379493022c123efb37d.svg";
export { ForwardRef as ReactComponent };